import Campaign from './Campaign';
import Wrapper from '../../assets/wrappers/JobsContainer';
import { useAllCampaignsContext } from '../../pages/AllCampaigns';
import CampaignPaginationContainer from './CampaignPaginationContainer';

const CampaignsContainer = () => {
  const { data } = useAllCampaignsContext();
  const { campaigns, totalCampaigns, numOfPages } = data;

  if (campaigns.length === 0) {
    return (
      <Wrapper>
        <h2>אין קמפיינים להציג...</h2>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h5>{totalCampaigns} קמפיינים נמצאו</h5>
      <div className="jobs">
        {campaigns.map((campaign) => (
          <Campaign key={campaign._id} {...campaign} />
        ))}
      </div>
      {numOfPages > 1 && <CampaignPaginationContainer />}
    </Wrapper>
  );
};

export default CampaignsContainer;
